import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';

export interface FundRequest {
  id: string;
  borrowerId?: string;
  customerName?: string;
  customerEmail?: string;
  requestedAmount: number;
  minimumAmount: number;
  monthlyInterestRate: number;
  purpose: string;
  status: string;
  adminNote?: string;
  debitId?: string;
  createdDate?: string;
}

export async function getFundRequests(status?: string) {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/admin/fund-requests`,
    params: status ? { status } : {},
  });
  return response.data || response;
}

export async function updateFundRequestStatus(id: string, status: string, adminNote?: string) {
  const response = await HttpClient.PUT({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/admin/fund-requests/${id}/status`,
    data: { status, adminNote },
  });
  return response.data || response;
}

export async function createFundRequestDebit(id: string, payload: {
  amount: number;
  outstanding: number;
  interestRate: number;
  type: string;
  durationType: string;
  startDate: string;
  endDate?: string;
  emiAmount: number;
  paymentDate: number;
  status: string;
}) {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/admin/fund-requests/${id}/debit`,
    data: payload,
  });
  return response.data || response;
}
